module.exports = require('./helpers/bundle-url').getBundleURL('7S8md') + "lslogo.44cdeb75.png" + "?" + Date.now();